export const pluralize = (count: number, word: string) => (count === 1 ? word : `${word}s`);

export const formatDocumentTitle = (name: string, citation?: string | null) => {
  return citation ? `${citation} ${name}` : name;
};

export type IRegulationTab = {
  id: string;
  title: string;
};

export const REGULATION_TABS: Record<'SCOPING' | 'REVIEW' | 'MAP', IRegulationTab> = {
  SCOPING: { id: 'scoping', title: 'Scoping' },
  REVIEW: { id: 'review', title: 'Review Obligations' },
  MAP: { id: 'map', title: 'Map Controls' },
};

export const getRegulationTabs = (
  regulationHasMappings: boolean | undefined | null,
  documentHasMappings: boolean | undefined | null,
): IRegulationTab[] => {
  if (documentHasMappings === false) {
    return [REGULATION_TABS.REVIEW];
  }

  if (!documentHasMappings && !regulationHasMappings) {
    return [REGULATION_TABS.REVIEW];
  }

  return [REGULATION_TABS.SCOPING, REGULATION_TABS.REVIEW, REGULATION_TABS.MAP];
};
